import { HTTP } from "@/utils/http-common"

export default {
  getDatasDashboardProjects($, id, datas) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/reports/${id}/dashboard_projects/`, datas)
        .then(r => {
          resolve(r.data)
        })
        .catch(error => {
          $.$store.commit("app/message", {
            msg: "Not allowed",
            color: "error"
          })
          reject(error)
        })
    })
  },

  getDatasDashboardNonConformities($, companyId, datas) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/reports/${companyId}/dashboard_non_conformities/`, datas)
        .then(r => {
          resolve(r.data)
        })
        .catch(error => {
          $.$store.commit("app/message", {
            msg: "Request failed: Cannot find associated project",
            color: "error"
          })
          reject(error)
        })
    })
  }
}
